<template>
  <div class="container">
    <span class="landscape_error" v-show="$store.getters['app/overlays'].show_landscape_error">
      <p id="text_error">Please set device to landscape</p>
    </span>

    <span v-show="$store.getters['app/overlays'].show_start_menu_overlay">
      <img v-if="(selected_text > -1) && ! start" draggable="false" class="clickable" id="quit_btn_top" @click="selectHomeScreen()" src="./assets/images/Asset 29.png" alt="">
      <img v-if="start" draggable="false" class="clickable" id="quit_btn_top" @click="selectHomeScreen()" src="./assets/images/Asset 30.png" alt="">
      <img class="background_image" src="./assets/images/Asset 37.png" alt="">

      <span v-if="selected_text == -1">
        <p id="main_text">Waar geloof jij in?</p>

        <img class="clickable" @click="selectAtheismeScreen()" id="logo_1" src="./assets/images/Asset 60.png" alt="">
        <img class="clickable" @click="selectIslam()" id="logo_2" src="./assets/images/Asset 64.png" alt="">
        <img class="clickable" @click="selectJodendomScreen()" id="logo_3" src="./assets/images/Asset 62.png" alt="">
        <img class="clickable" @click="selectChristian()" id="logo_4" src="./assets/images/Asset 65.png" alt="">
        <img class="clickable" @click="selectBoeddhismeScreen()" id="logo_5" src="./assets/images/Asset 61.png" alt="">
        <img class="clickable" @click="selectHindu()" id="logo_6" src="./assets/images/Asset 63.png" alt="">

        <img class="clickable" id="quit_btn" src="./assets/images/Asset 29.png" alt="">
      </span>

      <span v-if="selected_text > -1">
        <span v-if="selected_text == 0" id="text_intro_header" v-html="head_text"></span>
        <span v-html="texts[selected_text]" id="intro_text" :style="selected_text > 0 ? 'margin-top: 6%;' : ''"></span>

        <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./assets/images/Asset 51.png" alt="">
        <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./assets/images/Asset 51.png" alt="">
      </span>
    </span>
    
    <router-view/>
  </div>

</template>

<script>

export default {
  name: 'App',

  mounted() {
    this.selectDefault()
    this.checkLandscape()
  },

  created() {
    window.addEventListener("resize", this.checkLandscape);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkLandscape);
  },

  data() {
    return {
      start: true,
      selected_text: -1,
      texts: [
        ""
      ],
      head_text: ""
    };
  },

  methods: {
    goToStartPage() {
      this.$router.push('/start');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },

    selectChristian() {
      this.selected_text = 0;
      this.head_text = "Christendom";
      this.texts = [
        "Het christendom is een heel bijzondere religie die door heel veel mensen over de hele wereld wordt gevolgd. In het mooie Suriname, een land met prachtige bossen en rivieren, zijn zelfs meer dan de helft van de mensen christelijk! <br><br> Wist je dat er een school is die de naam draagt van een hele belangrijke persoon? De Graf von Zinzendorfschool is genoemd naar Nikolaus Ludwig Graf von Zinzendorf. Hij was een echte held, want hij heeft geholpen om het verhaal van het christelijke geloof te verspreiden. Dat is een beetje zoals een superheld, maar dan voor het geloof!",

        "In het jaar 1735 arriveerde er iets heel bijzonders in Suriname: de Evangelische Broedergemeente, ook wel bekend als de EBG. Ze zijn nu het grootste protestantse kerkgenootschap in het land. En wist je dat er een kerk is genaamd de Grote Stadskerk? Die is in 1778 gebouwd en is al heel oud! <br><br> De EBG begon met het vertellen van het verhaal van Jezus aan mensen in Suriname, zoals de inheemse bevolking, de mensen die op plantages werkten en zelfs de gevluchte mensen die eerder tot slaaf waren gemaakt (ze noemen hen nu marrons). <br><br> Maar dat is nog niet alles! De rooms-katholieke kerk is ook erg belangrijk in Suriname. In 1785 kwamen er missionarissen naar Suriname, en sindsdien zijn er veel scholen, kerken en internaten gebouwd. Als je een school ziet met \"Sint\" in de naam, dan betekent dat meestal dat het een katholieke school is."
      ];
    },
    selectDefault() {
      this.selected_text = 0;
      this.head_text = "";
      this.texts = [
        "In Suriname wonen veel mensen die in verschillende dingen geloven. Sommigen geloven in een god of goden, anderen geloven in de natuur, en er zijn zelfs mensen die in zichzelf geloven of helemaal nergens in geloven. En dat is helemaal oké! <br><br><br> Iedereen heeft het recht om te geloven in wat ze willen, dat is een belangrijk recht dat alle mensen hebben. Geloof hebben betekent dat je in iets speciaals gelooft en er vaak aan denkt.",

        "Sommige mensen gaan naar speciale plaatsen, zoals een kerk, een zaal, een tempel, een moskee, het bos of een andere plek waar ze zich het beste voelen om met hun geloof bezig te zijn. Anderen vinden het fijn om thuis te zijn en daar te denken aan hun geloof. <br><br> Het is belangrijk om te onthouden dat iedereen verschillend is, en dat is helemaal oké. Jij mag geloven in wat jij wilt en het op jouw eigen manier beleven. Het belangrijkste is dat je gelukkig bent met jouw geloof en dat je erover kunt praten als je dat wilt. Geloof in jezelf en in wat jou gelukkig maakt!"
      ];
    },
    selectHindu() {
      this.selected_text = 0;
      this.head_text = "Hindoeïsme";
      this.texts = [
        "Wist je dat het hindoeïsme een van de oudste religies ter wereld is? De mensen die deze religie volgen, noemen zichzelf hindoes, en ze wonen vooral in een land genaamd India. Het hindoeïsme begon ongeveer 4000 jaar geleden! Dat is echt heel, heel oud. <br><br> Ze hebben hele speciale boeken die ze als heilig beschouwen, zoals de Ramayana, Bhagavad Gita en Veda's. Maar weet je wat ze hun religie noemen? \"Sanatana Dharma\"! Dat betekent eigenlijk \"eeuwige wet.\" <br><br> Een slimme man genaamd Dayananda Sarasvati, ook bekend als Swami Dayanand. Hij richtte iets op dat de Arya Samaj heet. ",

        "Hij wilde de religieuze gebruiken terugbrengen naar de oude heilige Veda's en vond beeldenverering niet zo leuk. De Arya Samaj ging zelfs naar Suriname via andere landen! <br><br> In het hindoeïsme doen mensen veel verschillende dingen. Sommigen bidden elke dag en gaan naar tempels, terwijl anderen dat niet zo vaak doen. Maar weet je wat alle hindoes geloven? Ze geloven in reïncarnatie en karma! Dat betekent dat als je goed bent in dit leven, je in je volgende leven iets geweldigs kunt worden. Maar als je niet zo goed bent, zou je in een minder leuk leven kunnen worden geboren. <br><br> Het allerbelangrijkste doel voor een hindoe is iets heel speciaals: \"moksha\"! Dat betekent dat je ziel uiteindelijk niet meer terugkomt op aarde, maar iets heel bijzonders wordt. En om dat te bereiken, moeten hindoes goed leven volgens iets wat \"dharma\" wordt genoemd, wat eigenlijk gewoon betekent dat je je goed moet gedragen."
      ];
    },
    selectIslam() {
      this.selected_text = 0;
      this.head_text = "Islam";
      this.texts = [
        "De islam is een bijzonder geloof dat door veel mensen over de hele wereld wordt gevolgd. Het draait allemaal om Allah, de enige god waar moslims in geloven. Ze noemen hun geloof \"islam,\" wat betekent dat ze zich volledig aan Allah onderwerpen. <br><br> Mohammed is een hele belangrijke persoon in de islam. Moslims geloven dat hij een boodschapper en profeet van Allah was. Maar wist je dat ze ook geloven dat de allereerste profeet Adam was en de allerlaatste profeet Mohammed? Best cool, toch?",

        "Voor hun geloof kijken moslims naar de Koran, hun heilige boek. Ze bidden vijf keer per dag, en dat doen ze in de moskee, een speciale gebedsplaats. De persoon die hen leidt in het gebed noemen ze de imam. <br><br> Een hele belangrijke waarde in de islam is gastvrijheid. Dat betekent dat ze graag gasten verwelkomen en voor ze zorgen, zelfs met heerlijk eten en drinken! <br><br><br> Nu, laten we het hebben over de vijf belangrijke regels, de \"vijf zuilen\" van de islam: <br><br> 1. Sahadat: Dit is als je zegt dat je in Allah gelooft en dat Mohammed Zijn boodschapper is. Maar dat telt alleen als je het echt meent. <br><br>",

        "2. Salat: Moslims bidden vijf keer per dag. Dat is best vaak, maar het helpt hen om dichter bij Allah te zijn. <br><br> 3. Zakat: Ze geven geld aan mensen die het minder goed hebben. Zo laten ze hun vriendelijkheid en zorgzaamheid zien. <br><br> 4. Sawm Ramadan: Tijdens de heilige maand Ramadan vasten moslims. Dat betekent dat ze alleen op bepaalde tijden eten en drinken. <br><br> 5. Hadj: Als je gezond bent en genoeg geld hebt, moet je minstens één keer in je leven op bedevaart naar Mekka gaan. Dat is een hele speciale reis voor moslims."
      ];
    },
    selectAtheismeScreen() {
      this.selected_text = 0;
      this.head_text = "Atheïsme";
      this.texts = [
        "Atheïsme is een groot woord dat betekent dat je niet gelooft in een god, godin, of hogere macht. Mensen die atheïsten zijn, denken dat er geen wezens zijn die alles in de wereld hebben gemaakt of die over ons waken. <br><br> <u>Waarom zijn er atheïsten in Suriname?</u> <br><br> Suriname is een land waar veel verschillende culturen en religies samenkomen. Sommige mensen groeien op met verhalen over goden en godinnen, terwijl anderen dat niet doen. Atheïsten in Suriname hebben misschien andere ideeën over hoe de wereld werkt. Mensen worden atheïsten om verschillende redenen.",

        "Sommigen denken dat wetenschap alles kan verklaren, terwijl anderen geen bewijs hebben gezien voor het bestaan van goden. Iedereen heeft het recht om te geloven wat ze willen, en dat geldt ook voor atheïsten. Respecteer ieders overtuigingen Het is belangrijk om respect te hebben voor de overtuigingen van andere mensen, of ze nu geloven in goden, godinnen, of helemaal niet. In Suriname is er vrijheid van religie, wat betekent dat iedereen kan geloven wat ze willen. Het is oké als iemand atheïst is, en het is oké als iemand in goden gelooft. We moeten allemaal vriendelijk en respectvol met elkaar omgaan, ongeacht onze overtuigingen."
      ];
    },
    selectBoeddhismeScreen() {
      this.selected_text = 0;
      this.head_text = "Boeddhisme";
      this.texts = [
        "Boeddhisme is een oude levenswijze die vriendelijkheid, vrede en mededogen benadrukt, en het geluk bevordert door goede daden. <br><br><u>Boeddhisme in Suriname</u><br><br> In Suriname, waar mensen van diverse culturen en religies wonen, volgen sommigen het boeddhisme, geleid door Boeddha's leer voor een harmonieus leven. Goed Doen en Respect voor de Natuur Boeddhisten geloven in goede daden en vriendelijkheid voor alle levende wezens, inclusief dieren. Ze hebben diep respect voor de natuur en het milieu. Feesten en Festivals Vesak is een belangrijk festival dat de geboorte, verlichting en dood van Boeddha viert. Het omvat versieringen met lichtjes en liefdadigheid.",

        "Boeddhisme in Suriname biedt waardevolle lessen in vriendelijkheid en begrip, waardoor mensen geluk en vrede vinden. Misschien kun je ook leren van deze wijsheid en vriendelijkheid uitdragen in jouw wereld. Denk eraan, Suriname heeft naast prachtige natuur en diverse culturen ook een speciale plek voor boeddhisme, dat ons kan helpen een betere wereldburger te worden."
      ];
    },
    selectJodendomScreen() {
      this.selected_text = 0;
      this.head_text = "Jodendom";
      this.texts = [
        "Het jodendom is een van de oudste religies ter wereld. Het begon meer dan 3000 jaar geleden in het Midden-Oosten, in een land dat we nu Israël noemen. Joden geloven in één god en hebben een heilig boek dat de Torah heet. De Torah bevat verhalen en regels die belangrijk zijn voor het joodse geloof. <br><br> <u>De Synagoge</u><br><br> Joden komen samen in een speciale plaats van aanbidding die een synagoge wordt genoemd. In de synagoge bidden ze tot God en bestuderen ze de Torah. Elke synagoge heeft een speciale kast, de ark, waarin rollen met de Torah worden bewaard. Deze rollen zijn erg belangrijk voor de joodse gemeenschap.",

        "<u>Feestdagen</u><br><br> Het jodendom heeft veel feestdagen, en sommige daarvan zijn erg bekend. Hier zijn een paar: <br><br>1. Chanoeka: Tijdens Chanoeka vieren joden het wonder van de olielampen die acht dagen lang bleven branden in de tempel. Ze steken elke avond kaarsen aan op een speciale kandelaar, de menora. <br><br>2. Pesach: Dit is het joodse feest van de bevrijding uit Egypte. Tijdens Pesach eten joden matzes, ongerezen brood, om deze gebeurtenis te herdenken. <br><br>3. Rosj Hasjana en Jom Kipoer: Dit zijn de joodse nieuwjaar- en vergevingsdagen. Joden bidden en denken na over hun gedrag in het afgelopen jaar, en vragen om vergeving voor eventuele fouten.",

        "<u>Kosjer eten</u><br><br> Een ander belangrijk onderdeel van het jodendom is het eten van kosjer voedsel. Kosjer betekent <u>geschikt</u> of <u>rein</u>. Joden volgen speciale regels over wat ze wel en niet kunnen eten. Bijvoorbeeld, ze eten geen varkensvlees en combineren geen melk en vlees in dezelfde maaltijd.",

        "<u>Bar Mitswa en Bat Mitswa</u><br><br> Wanneer joodse kinderen 13 jaar oud worden (jongens) of 12 jaar oud (meisjes), vieren ze een speciale gebeurtenis. Voor jongens heet dit een Bar Mitswa, en voor meisjes een Bat Mitswa. Het is een belangrijke overgang naar volwassenheid in de joodse traditie. Het jodendom is een rijke en diverse religie met veel tradities en rituelen. Of je nu joods bent of niet, het is altijd interessant om te leren over de overtuigingen en gewoonten van andere mensen. Wie weet, misschien kun je binnenkort een joodse vriend ontmoeten en hen wat meer vertellen over hun eigen geloof!"
      ];
    },
    selectHomeScreen() {
      this.start = false
      this.selected_text = -1;
      this.head_text = "";
      this.texts = [
        ""
      ];
    },
    nextText() {
      this.selected_text++;
    },
    prevText() {
      this.selected_text--;
    },
    checkLandscape() {
      if ( window.innerWidth < ( window.innerHeight * 1.5 ) ) {
        if ( ! this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: true
          });
      } else {
        if ( this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: false
          });
      }
    }
  },

  computed: {},

  watch: {}
}
</script>

<style>
  .landscape_error {
    background-color: grey;
    width: 105%;
    height: 105%;
    position: absolute;
    z-index: 3;
  }

  #text_error {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    color: white;
    width: 95%;
    font-size: 5.5vw;
    text-align: center;
  }

  @font-face {
    font-family: "LuckiestGuy";
    src: url('./assets/geloof/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  #text_intro_header {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 6%;
    width: 50%;
    left: 25%;
    color: #fff;
    font-size: 5vw;
    text-align: center;
  }
  #intro_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 13%;
    width: 60%;
    left: 20%;
    color: #fff;
    font-size: 2vw;
    text-align: center;
  }

  .background_image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

  #main_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 10%;
    width: 60%;
    left: 20%;
    font-size: 5.5vw;
    text-align: center;
    color: white;
  }

  body {
    cursor: url('./assets/cursor/material-wood-cursor.png'), default;	
  }

  #start_btn {
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
    position: absolute;
    margin-top: 17%;
    left: 30%;
    width: 20%;
  }

  .clickable:hover {
    opacity: 0.7;
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
  }

  #quit_btn {
    position: absolute;
    margin-top: 1%;
    right: 3%;
    width: 20%;
  }

  #logo_1 {
    position: absolute;
    margin-top: 27%;
    left: 10%;
    width: 14%;
  }
  #logo_2 {
    position: absolute;
    margin-top: 27%;
    left: 23%;
    width: 15%;
  }
  #logo_3 {
    position: absolute;
    margin-top: 26%;
    left: 36%;
    width: 14%;
  }
  #logo_4 {
    position: absolute;
    margin-top: 30.5%;
    left: 49%;
    width: 14%;
  }
  #logo_5 {
    position: absolute;
    margin-top: 27%;
    left: 63%;
    width: 13%;
  }
  #logo_6 {
    position: absolute;
    margin-top: 27%;
    left: 75.5%;
    width: 13%;
  }

  #quit_btn_top {
    position: absolute;
    margin-top: 2%;
    right: 3%;
    width: 15%;
    z-index: 1;
  }

  #next_btn {
    position: absolute;
    margin-top: 44%;
    left: 73%;
    width: 5%;
  }
  #prev_btn {
    transform: rotate(180deg);
    position: absolute;
    margin-top: 44%;
    left: 20%;
    width: 5%;
  }

  body {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
</style>
